import { Factory } from "@/repository/Factory";
const Dealer = Factory.get("dealer");

const state = {
  companies: []
};

const getters = {
  getCompanies: state => state.companies
};

const mutations = {
  setCompanies: (state, payload) => (state.companies = [...payload])
};

const actions = {
  // Get Dealer Companies
  async getDealerCompanies({ commit }, payload) {
    commit("setCompanies", []);

    return await Dealer.getDealerCompanies(payload).then(
      response => {
        if (response.status === 200) {
          commit("setCompanies", response.data);

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Create Dealer Company
  async createDealerCompany({ commit }, payload) {
    return await Dealer.createDealerCompany(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Update Dealer Company
  async updateDealerCompany({ commit }, payload) {
    return await Dealer.updateDealerCompany(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Delete Dealer Company
  async deleteDealerCompany({ commit }, payload) {
    return await Dealer.deleteDealerCompany(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Get Dealers By Company
  async getDealersByCompany({ commit }, payload) {
    return await Dealer.getDealersByCompany(payload).then(
      response => {
        if (response.status === 200) {
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Delete Dealer User
  async deleteDealer({ commit }, payload) {
    return await Dealer.deleteDealer(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Update Dealer User
  async updateDealer({ commit }, payload) {
    return await Dealer.updateDealer(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );
          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        commit(
          "setToast",
          {
            message: message,
            type: "error",
            show: true
          },
          { root: true }
        );

        return Promise.reject(message);
      }
    );
  },

  // Invite Dealer
  async inviteDealer({ commit }, payload) {
    return await Dealer.inviteDealer(payload).then(
      response => {
        if (response.status === 200 || response.status === 201) {
          commit(
            "setToast",
            {
              message: response.data.message,
              type: "success",
              show: true
            },
            { root: true }
          );

          return Promise.resolve(response.data);
        }

        return Promise.reject(response);
      },
      error => {
        const message =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        return Promise.reject(message);
      }
    );
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
